<template>
    <div class="file-column-mapping mb-5">
        <div class="d-flex flex-column gap-1">
            <h4>Columns to Export</h4>
            <p class="mb-1">Customize the data being exported to your file. This configuration will be saved for this audience moving forward.</p>
        </div>
        <div class="d-flex flex-column gap-md-3 gap-0 mb-4">
            <section v-for="(column, i) in mapping.slice(0,2)" :id="i == 0 ? 'primary-key-column-mapping' : 'column-mapping'">
                <div v-if="i>=1" class="w-100 d-flex flex-column gap-2">
                    <!-- Table layout for medium and larger screens -->
                    <div class="row">
                        <div class="col mb-3">
                            <div class="card p-0 position-relative">
                                <button class="btn btn-secondary btn-icon-only-md d-none d-md-block position-absolute" 
                                        @click="toggleExpand" 
                                        data-bs-toggle="tooltip" 
                                        title="Toggle full width"
                                        style="right: 12px; top: 5px;">
                                    <img :src="is_expanded ? '/img/icons/avid-icons/minimize-4.svg' : '/img/icons/avid-icons/maximize-4.svg'" style="width:14px;" class="icon pe-0" alt="">
                                </button>
                                <table class="column-mapping-table mapping-table">
                                    <thead class="w-100">
                                        <tr>
                                            <th>
                                                <div class="flex-column">
                                                    <h4 class="ms-2">Source Column</h4>
                                                </div>
                                            </th>
                                            <th style="width:60px!important;">
                                                <!-- <div>
                                                    <small>Maps to</small>
                                                </div> -->
                                            </th>
                                            <th>
                                                <div class="flex-column">
                                                    <h4 class="ms-2">Output Name</h4>
                                                </div>
                                            </th>
                                            <th style="width:60px!important;"></th>
                                        </tr>
                                    </thead>
                                    <draggable v-model="mapping" tag="tbody" handle=".handle" class="w-100 m-2" item-key="id" :disabled="!if_allow_edit">
                                        <template #item="{ element: column, index: j }">
                                            <tr v-if="j > 0" class="mb-2">
                                                <td class="mapping-grid__source">
                                                    <div class="input-group mb-2" :class="{'is-invalid' : errors[j].source != ''}">
                                                        <input type="text" class="form-control" v-model="column.source_column.value" :class="{'is-invalid' : errors[j].source != ''}" v-if="isConstant(column)" @change="updateConstant(column)"
                                                            :key="column.id" :disabled="!if_allow_edit" aria-label="Value">
                                                        <accordion-select v-model="column.source_column.value" :key="column.source_column.id" :class="{'is-invalid' : errors[j].source != ''}" v-else 
                                                        :options="source_columns" @update:modelValue="updateDestination(column)" :if_allow_edit="if_allow_edit"></accordion-select>
                                                        <button class="btn btn-secondary ps-2" data-bs-toggle="tooltip" title="Use a value from a column" @click="toggleConstant(column)" v-if="isConstant(column)" :disabled="!if_allow_edit">
                                                            <img class="icon" src="/img/icons/avid-icons/map.svg" alt="">
                                                        </button>
                                                        <button class="btn btn-secondary ps-2" data-bs-toggle="tooltip" title="Use a constant value" @click="toggleConstant(column)" v-else :disabled="!if_allow_edit">
                                                            <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                                        </button>
                                                    </div>
                                                    <!-- <div class="close-btn d-sm-none" v-if="!column.is_primary_identifier && if_allow_edit">
                                                        <button class="btn btn-none px-0" @click="removeColumn(j-1);"><img class="icon" src="/img/icons/avid-icons/close.svg" alt=""></button>
                                                    </div>
                                                    <div v-else-if="!column.is_primary_identifier && !if_allow_edit" class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                        <button class="btn btn-none px-0" :disabled="true">
                                                            <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                                                        </button>
                                                    </div> -->
                    
                                                    <div class="text-danger invalid-feedback" v-if="errors[j].source != ''">
                                                        {{ errors[j].source }}
                                                    </div>
                                                </td>
                                                <td class="mapping-grid_map_to">
                                                    <div class="d-flex align-items-center">
                                                        <small>Maps to</small>
                                                    </div>
                                                </td>
                                                <td class="mapping-grid__destination">
                                                    <div class="d-flex mb-2">
                                                        <input type="text" class="ms-2 ms-md-0 form-control" v-model="column.destination_column" :class="{'is-invalid' : errors[j].destination != ''}" 
                                                        :key="'dest'+column.id" @change="errors[j].destination = ''" :disabled="!if_allow_edit" aria-label="Destination Column">
                                                    </div>
                                                    <div class="text-danger invalid-feedback" v-if="errors[j].destination != ''">
                                                        {{ errors[j].destination }}
                                                    </div>
                                                </td>
                                                <td class="mapping-grid__action">
                                                    <div>
                                                        <button class="btn btn-white btn-icon-only-sm handle border-0" :disabled="!if_allow_edit">
                                                            <img src="/img/icons/avid-icons/vertical-dots.svg" alt="drag" class="icon">
                                                        </button>
                                                        <button v-if="j > 1 && if_allow_edit" class="mapping-grid__button btn btn-white btn-icon-only-sm" @click="removeColumn(j);">
                                                            <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                                        </button>
                                                        <div v-else-if="j > 1 && !if_allow_edit" class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                            <button class="btn btn-white btn-icon-only-sm" :disabled="true">
                                                                <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </draggable>
                                </table>

                                <!-- Buttons -->
                                <div class="mb-2 mx-3">
                                    <button v-if="if_allow_edit" class="btn btn-secondary" @click="addColumnMapping()" >
                                        <i class="fas fa-plus"></i> Add Column
                                    </button>
                                    <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                        <button class="btn btn-secondary" :disabled="true">
                                            <i class="fas fa-plus"></i> Add Column
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-xl-block drill-down mb-3" :class="(is_expanded ? 'col-12' : 'col-4')">
                            <preview-table :client="client" :source="source"
                                :source_columns="source_columns" :data_type="null"></preview-table>
                        </div>
                    </div>

                    <!-- Card layout for small screens -->
                    <div class="d-md-none">
                        <template v-for="(column, j) in mapping" :key="column.id">
                            <div v-if="j > 0" class="card py-2 px-3 mb-3" style="background-color: #FAFAFA;">
                                <div class="d-flex justify-content-between align-items-center">
                                    <strong>Column {{ j }}</strong>
                                    <div class="mapping-grid__action d-flex align-items-center gap-2">
                                        <!-- drag handle (optional) -->
                                        <button class="btn btn-none px-0 handle border-0" :disabled="!if_allow_edit">
                                            <img src="/img/icons/avid-icons/vertical-dots.svg" alt="drag" class="icon">
                                        </button>
                                        <!-- delete -->
                                        <button v-if="j > 1 && if_allow_edit" class="mapping-grid__button btn btn-none px-0" @click="removeColumn(j);">
                                            <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                        </button>
                                        <div v-else-if="j > 1 && !if_allow_edit" class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                            <button class="btn btn-none px-0" :disabled="true">
                                                <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Source column -->
                                <div class="mb-2 w-100">
                                    <label class="form-label">Source Column</label>
                                    <div class="mapping-grid__source">
                                        <div class="input-group w-100" :class="{'is-invalid' : errors[j].source != ''}">
                                            <input type="text" class="form-control" v-model="column.source_column.value" :class="{'is-invalid' : errors[j].source != ''}" v-if="isConstant(column)" @change="updateConstant(column)"
                                                :key="column.id" :disabled="!if_allow_edit" aria-label="Value">
                                            <accordion-select v-model="column.source_column.value" :key="column.source_column.id" :class="{'is-invalid' : errors[j].source != ''}" v-else 
                                            :options="source_columns" @update:modelValue="updateDestination(column)" :if_allow_edit="if_allow_edit"  style="width: calc(100% - 46px);"></accordion-select>
                                            <button class="btn btn-secondary ps-2" data-bs-toggle="tooltip" title="Use a value from a column" @click="toggleConstant(column)" v-if="isConstant(column)" :disabled="!if_allow_edit">
                                                <img class="icon" src="/img/icons/avid-icons/map.svg" alt="">
                                            </button>
                                            <button class="btn btn-secondary ps-2" data-bs-toggle="tooltip" title="Use a constant value" @click="toggleConstant(column)" v-else :disabled="!if_allow_edit">
                                                <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                            </button>
                                        </div>

                                        <div class="text-danger invalid-feedback" v-if="errors[j].source != ''">
                                            {{ errors[j].source }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Output name -->
                                <div class="mb-1">
                                    <label class="form-label">Output Name</label>
                                    <div class="mapping-grid__destination w-100">
                                        <div class="mb-2 w-100 d-flex flex-column">
                                            <input type="text" class="w-100 form-control" v-model="column.destination_column" :class="{'is-invalid' : errors[j].destination != ''}" 
                                            :key="'dest'+column.id" @change="errors[j].destination = ''" :disabled="!if_allow_edit" aria-label="Destination Column">
                                        </div>
                                        <div class="text-danger invalid-feedback" v-if="errors[j].destination != ''">
                                            {{ errors[j].destination }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                </div>
            </section>

        </div>
        <div v-if="Object.keys(questions).length > 0" class="mb-4">
            <div class="d-flex flex-column gap-1">
                <h4>Questions About Your Export</h4>
                <p class="mb-3">Depending upon how the export will be used, you may want more or less information. Answer the questions below to ensure you get the data you're looking for.</p>
            </div>
            <div v-for="key in Object.keys(questions)" :key="key" class="ms-2">
                <div class="form-check form-switch d-inline-flex align-items-center gap-2 my-0">
                    <input class="form-check-input mt-0" type="checkbox" role="switch" v-model="keys[key]" @change="setPrioritization()" :disabled="!if_allow_edit" aria-label="Keys[key]">
                    <span v-html="questions[key]"></span>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="accordion-item advanced-settings mt-2">
                <h2 class="accordion-header" id="advancedSettingsHeading">
                    <button class="accordion-button h4 px-2 mb-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#advancedSettingsCollapse" aria-expanded="false" aria-controls="advancedSettingsCollapse">
                        Advanced Settings
                    </button>
                </h2>
                <div id="advancedSettingsCollapse" class="accordion-collapse collapse" aria-labelledby="advancedSettingsHeading">
                    <div class="accordion-body pt-2 px-2">
                        <div class="w-100 d-flex flex-column gap-2">
                            <div class="mapping" id="primary-key-column" :class="{ 'is-invalid' : errors[0].source != '' }">
                                <div class='w-100'>
                                    <label>{{ source.data_source.name }} Source Column(s)</label>
                                    <accordion-multi-select v-model="mapping[0].source_column" @input="selectKeyColumn($event, 0)" :class="{'is-invalid' : errors[0].source != ''}"
                                        :options="source_columns" :key="mapping[0].id" :field_name="'primary_key_column'" :if_allow_edit="if_allow_edit"></accordion-multi-select>
                                    <div class="text-danger invalid-feedback" v-if="errors[0].source != ''">
                                        {{ errors[0].source }}
                                    </div>
                                </div>
                            </div>
                            <div class="mapping" id="prioritization-columns">
                                <div class="row">
                                    <div class="col-12">
                                        <label>Prioritization Column(s)</label><br>
                                        <small class="mb-2 d-block text-muted">If there are multiple records with the same primary key, how should Avid determine which one to sync?</small>
                                    </div>
                                    <div class="col-12 col-lg-9 mb-2" :class="prioritization_column.length > 1 ? 'd-grid' : 'd-flex'">
                                        <template v-for="(priority, i) in prioritization_column">
                                            <b v-if="prioritization_column.length > 1" class="fs-5">{{ i+1 }}.</b>
                                            <div class="input-group position-relative">
                                                <accordion-select v-model="priority.column" :options="source_columns" :if_allow_edit="if_allow_edit"></accordion-select>
                                                <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" 
                                                aria-expanded="false" :disabled="!if_allow_edit">{{ priority.sort == 'DESC'? 'Descending' : 'Ascending' }}</button>
                                                <ul class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                    <li><a class="dropdown-item" href="#" @click.prevent="priority.sort = 'ASC'">Ascending</a></li>
                                                    <li><a class="dropdown-item" href="#" @click.prevent="priority.sort = 'DESC'">Descending</a></li>
                                                </ul>
                                            </div>
                                            <button v-if="prioritization_column.length > 1 && if_allow_edit" class="mapping-grid__button btn btn-primary btn-icon-only-sm" v-on:click="prioritization_column.splice(i, 1);">
                                                <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                            </button>
                                            <div v-else-if="prioritization_column.length > 1 && !if_allow_edit" class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                                <button class="btn btn-secondary btn-icon-only-sm" :disabled="true">
                                                    <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                                </button>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <button v-if="if_allow_edit" class="btn btn-secondary" @click="addPriorityColumn()"><i class="fas fa-plus"></i> Add Prioritization</button>
                                        <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                            <button class="btn btn-secondary" :disabled="true">
                                                <i class="fas fa-plus"></i> Add Prioritization
                                            </button>
                                        </div>                                    
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { defineComponent } from 'vue';
import draggable from 'vuedraggable';

export default defineComponent({
    name: 'FileColumnMapping',
    components: { 
        draggable 
    },
    props: {
        client: {
            type: Object,
        },
        destination: {
            type: Object,
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        source: {
            type: Object
        },
        source_columns: {
            type: Array,
            default: () => []
        },
        if_allow_edit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            advanced_setting: false,
            questions: [],
            mapping: [],
            errors: [],
            prioritization_column:[{
                column: '',
                sort: 'DESC'
            }],
            keys: [],
            formatted_columns: [],
            is_expanded: false
        };
    },
    beforeMount() {
        this.setupUI();

        //For the error message, set the default value to false.
        this.errors = [];
        for(let i = 0; i < this.mapping.length; i++) {
            this.errors.push({
                source: "",
                destination: ""
            });
        }
        this.formatted_columns = this.getFormattedColumns(this.source_columns);
        if(this.source.prioritization_column != null)
            this.prioritization_column = this.source.prioritization_column;
    },
    mounted() {
        //Ensure the tooltips show up
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (let i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                    // Hide the tooltip using the index passed to the closure
                    tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                    // Hide the tooltip using the index passed to the closure
                    tooltipList[index].hide();
                });
            })(i);
        }
    },
    watch: {
        modelValue: {
            handler(val) {
                if(val != null)
                    this.mapping = val;
                else
                    this.mapping = this.getDefaultMapping();
            },
            immediate: true
        },
        mapping: {
            handler(n, o) {
                this.$emit('update:modelValue', this.mapping);
                this.$emit('changeMappingDetails', this.mapping);
                if (this.mapping.length > this.errors.length){
                    for(let i = 0; i < this.mapping.length - this.errors.length; i++) {
                        this.errors.push({
                            source: "",
                            destination: ""
                        });
                    }
                }
            },
            deep: true
        },
        prioritization_column: {
            handler() {
                this.$emit('prioritize', this.prioritization_column);
            },
            deep: true
        }
    },
    methods: {
        getFormattedColumns(db_columns) {
            const columns = [];
            db_columns.forEach(column => {
                column.main_category = "Columns";
                columns.push(column);
            });
            return columns;
        },
        addPriorityColumn() {
            this.prioritization_column.push({
                column: '',
                sort: 'DESC'
            });
        },
        setPrioritization() {
            if(this.source.source == "data_blend" && this.source.data_source.type == 'constituent'){
                //Update prioritization when this updates
                //Remove the existing primary keys
                this.mapping[0].source_column = [this.getGeneratedSourceColumn('id')];
                
                // Store the original prioritization columns to preserve custom ones
                const originalPrioritizationColumns = [...this.source.prioritization_column];
                
                this.prioritization_column = [];
                for(const key in this.keys){
                    if(key == 'contacts' && this.keys[key] == true)
                        this.mapping[0].source_column.push(this.getGeneratedSourceColumn('contacts.contact_id'));
                    else if(key == 'email' && this.keys[key] == true)
                        this.mapping[0].source_column.push(this.getGeneratedSourceColumn('contacts.email.email'));
                    else if(key == 'phone' && this.keys[key] == true)
                        this.mapping[0].source_column.push(this.getGeneratedSourceColumn('contacts.phone.phone'));
                    else if(key == 'address' && this.keys[key] == true)
                        this.mapping[0].source_column.push(this.getGeneratedSourceColumn('contacts.address.city'));
                }
                //Loop through the questions and add sorting accordingly
                for(const key in this.questions){
                    if(key == 'email')
                        this.prioritization_column.push({column: 'contacts.email.email_is_primary', sort: 'DESC'});
                    else if(key == 'phone')
                        this.prioritization_column.push({column: 'contacts.phone.phone_is_primary', sort: 'DESC'});
                    else if(key == 'address')
                        this.prioritization_column.push({column: 'contacts.address.is_primary', sort: 'DESC'});
                }
                this.prioritization_column.push({column: 'giving_history.last_gift.date', sort: 'DESC'});

                //Loop through the rest of the mappings to see if it has transactions
                for(let i = 1; i < this.mapping.length; i++){
                    if(this.mapping[i].source_column.value == null) continue;

                    const parts = typeof this.mapping[i].source_column.value == 'object' ? 
                        this.mapping[i].source_column.value.value.split('.') : 
                        this.mapping[i].source_column.value.split('.');
                    if(parts.includes('transactions')){
                        //This needs to be added to the group by
                        this.mapping[0].source_column.push(this.getGeneratedSourceColumn('transactions.id'));
                        break;
                    }
                }
                
                // Preserve any existing prioritization columns that don't match the specific patterns
                const excludedColumns = [
                    'contacts.email.email_is_primary',
                    'contacts.phone.phone_is_primary', 
                    'contacts.address.is_primary',
                    'giving_history.last_gift.date'
                ];
                
                originalPrioritizationColumns.forEach(element => {
                    if (!excludedColumns.includes(element.column)) {
                        this.prioritization_column.push(element);
                    }
                });
            }
            else {
                //
            }
            this.$emit('prioritize', this.prioritization_column);
        },
        addColumnMapping(){
            this.mapping.push(this.getMapping());
        },
        updateDestination(column) {
            //If column.source_column is an arry, just stop and return
            if(Array.isArray(column.source_column)) return;

            //Split the col by . and then call the filter to transform it
            if(column.source_column.value == null){
                return;
            }

            const parts = typeof column.source_column.value == 'object' ? 
                column.source_column.value.value.split('.') : 
                column.source_column.value.split('.');
            //Call the propercase vue filter on the last element of the array
            const text = this.propercase(parts[parts.length - 1]);

            //if(column.destination_column == null || column.destination_column == '')
            column.destination_column = text;

            this.addQuestions(column);
        },
        addQuestions(col) {
            let source = col.source_column;
            //If it isn't an array, make it one
            if(!Array.isArray(source))
                source = [source];

            for(let j = 0; j < source.length; j++){
                if(source[j].value == null) continue;

                const parts = typeof source[j].value == 'object' ? 
                    source[j].value.value.split('.') : 
                    source[j].value.split('.');
                if(parts.length == 1)
                    return;

                if(this.source.source == "data_blend" && this.source.data_source.type == 'constituent'){
                    // if the parts contains "contacts"
                    if(parts.includes("contacts"))
                        this.questions['contacts'] = 'Export every individual associated with an account? <em>(If unchecked, it will select only a single individual from each account)</em>';
                    if(parts.includes("email"))
                        this.questions['email'] = 'Export every email address? <em>(This can create multiple rows for each contact.)</em>';
                    if(parts.includes("phone"))
                        this.questions['phone'] = 'Export every phone number? <em>(This can create multiple rows for each contact.)</em>';
                    if(parts.includes("address"))
                        this.questions['address'] = 'Export every address for each person? <em>(This can create multiple rows for each contact.)</em>';
                }
                else {
                    //
                }

                //Loop through the questions as key / value
                for(const key in this.questions){
                    //See if the key exists in any of the existing mappings
                    let found = false;
                    for(let i = 0; i < this.mapping.length; i++){
                        if(this.mapping[i].source_column.value == null) continue;

                        if(Array.isArray(this.mapping[i].source_column) && this.mapping[i].source_column.some(obj => obj.value === key)){
                            found = true;
                            break;
                        }
                        else{
                            const parts = typeof this.mapping[i].source_column.value === 'object'
                                ? (this.mapping[i].source_column.value?.value || '').split('.')
                                : (this.mapping[i].source_column.value || '').split('.');
                            if(parts.includes(key)){
                                found = true;
                                break;
                            }
                        }
                    }
                    //If it wasn't found, remove the question
                    if(!found)
                        delete this.questions[key];
                }
            }
            this.$forceUpdate();
        },
        removeQuestions(col) {
            const col_parts = col.source_column.value
                ? (typeof col.source_column.value === 'object'
                    ? (col.source_column.value?.value || '').split('.')
                    : (col.source_column.value || '').split('.'))
                : [];
            if(col_parts.length == 1)
                return;

            const arr = [];
            //Look through the mappings and identify what parts they have
            for(let i = 0; i < this.mapping.length; i++){
                if(this.mapping[i].source_column.value == null) continue;
                let tmp = this.mapping[i].source_column;

                if(!Array.isArray(tmp)) tmp = [tmp];

                for(let j = 0; j < tmp.length; j++){
                    const parts = typeof tmp[j].value === 'object'
                        ? (tmp[j].value?.value || '').split('.')
                        : (tmp[j].value || '').split('.');
                    if(parts.includes("contacts"))
                        arr.push("contacts");
                    if(parts.includes("email"))
                        arr.push("email");
                    if(parts.includes("phone"))
                        arr.push("phone");
                    if(parts.includes("address"))
                        arr.push("address");
                }
            }

            if(!arr.includes("contacts") && col_parts.includes("contacts"))
                delete this.questions['contacts'];
            if(!arr.includes("email") && col_parts.includes("email"))
                delete this.questions['email'];
            if(!arr.includes("phone") && col_parts.includes("phone"))
                delete this.questions['phone'];
            if(!arr.includes("address") && col_parts.includes("address"))
                delete this.questions['address'];
        },
        resetMapping() {
            this.$emit('update:modelValue', null);
        },
        setupUI() {
            //Set the default columns or whatever was sent to me
            if(this.modelValue != null && this.modelValue.length > 0) {
                this.mapping = this.modelValue;

                //Remove any columns that are no longer available
                for(let i = 0; i < this.mapping.length; i++){
                    //If it is an array...
                    if(Array.isArray(this.mapping[i].source_column)) {
                        for(let j = 0; j < this.mapping[i].source_column.length; j++){
                            //If the value is in the list of source_columns
                            if(this.mapping[i].source_column[j].main_category=="Columns" && !this.source_columns.some(obj => obj.value === this.mapping[i].source_column[j].value)){
                                this.mapping[i].source_column[j] = this.getBlankSourceColumn();
                                break;
                            }
                            else{
                                this.addQuestions(this.mapping[i]);
                            }
                        }
                    }
                    //Just look at the object
                    else if(this.mapping[i].source_column.main_category=="Columns" && !this.source_columns.some(obj => obj.value === this.mapping[i].source_column.value)){
                        //If it is the primary column, it should be an array
                        if(this.mapping[i].is_primary_identifier == 1)
                            this.mapping[i].source_column = [this.getBlankSourceColumn()];
                        else
                            this.mapping[i].source_column = this.getBlankSourceColumn();
                    }
                    else {
                        this.addQuestions(this.mapping[i]);
                    }
                }

                //Look through the primary key and set the checkboxes
                for(let j = 0; j < this.mapping[0].source_column.length; j++){
                    for(const key in this.questions){
                        if(this.mapping[0].source_column[j].value == 'contacts.contact_id')
                            this.keys['contacts'] = true;
                        else if(this.mapping[0].source_column[j].value == 'contacts.email.email')
                            this.keys['email'] = true;
                        else if(this.mapping[0].source_column[j].value == 'contacts.phone.phone')
                            this.keys['phone'] = true;
                        else if(this.mapping[0].source_column[j].value == 'contacts.address.city')
                            this.keys['address'] = true;
                    }
                }

                this.setPrioritization();
            }
            else {
                this.mapping = this.getDefaultMapping();
                //Add the questions at the end
                if(this.mapping && this.mapping.length > 0){
                    for(let i = 0; i < this.mapping.length; i++)
                        this.addQuestions(this.mapping[i]);
                }
            }
        },
        selectKeyColumn(event, index){
            let last_element = this.mapping[index].source_column[this.mapping[index].source_column.length - 1];
            if(!last_element.value) { // the last element is a search inputEvent, we should update it
                this.mapping[index].source_column[this.mapping[index].source_column.length - 1] = event;
            } else { // the last element is a value, we should add a new element
                this.mapping[index].source_column.push(event);
            }
        },
        getColumnText(column) {
            const foundInstance = this.flat_dest_columns.find(item => item.value === column);

            if(foundInstance == null)
                return column;

            return foundInstance.text;
        },
        getDefaultMapping() {
            const arr = [];
            //If it is a constituent blend, it will be the account ID
            if(this.source.source == "data_blend" && this.source.data_source.type == 'constituent'){
                arr.push(this.getMapping('id', true));
                arr.push(this.getMapping('id'));
                arr.push(this.getMapping('contacts.contact_id'));
                arr.push(this.getMapping('contacts.first_name'));
                arr.push(this.getMapping('contacts.last_name'));
                arr.push(this.getMapping('contacts.address.address_1'));
                arr[arr.length-1].destination_column = 'Address Line 1';
                arr.push(this.getMapping('contacts.address.city'));
                arr.push(this.getMapping('contacts.address.region'));
                arr.push(this.getMapping('contacts.address.postal_code'));
                arr.push(this.getMapping('contacts.email.email'));
                arr.push(this.getMapping('contacts.phone.phone'));
                arr.push(this.getMapping('giving_summary.giving_level'));
                arr.push(this.getMapping('giving_history.first_gift.amount'));
                arr[arr.length-1].destination_column = 'First Gift Amount';
                arr.push(this.getMapping('giving_history.first_gift.date'));
                arr[arr.length-1].destination_column = 'First Gift Date';
                arr.push(this.getMapping('giving_history.last_gift.amount'));
                arr[arr.length-1].destination_column = 'Last Gift Amount';
                arr.push(this.getMapping('giving_history.last_gift.date'));
                arr[arr.length-1].destination_column = 'Last Gift Date';
            }
            else if(this.source.source == "data_blend" && this.source.data_source.type == 'subscriber'){
                arr.push(this.getMapping('email', true));
                arr.push(this.getMapping('contact.first_name'));
                arr.push(this.getMapping('contact.last_name'));
                arr.push(this.getMapping('email'));
                arr.push(this.getMapping('source.email_source'));
                arr.push(this.getMapping('source.email_source_type'));
                arr.push(this.getMapping('status.name'));
                arr[arr.length-1].destination_column = 'Email Status';
                arr.push(this.getMapping('engagement_summary.overall_engagement_recency.label'));
                arr[arr.length-1].destination_column = 'Time Since Last Engement';
                arr.push(this.getMapping('date_created'));
            }
            else {
                arr.push(this.getMapping(null, true));
                arr.push(this.getMapping(null));
            }
            return arr;
        },
        getMapping(col, is_primary = false) {
            //Split the col by . and then call the filter to transform it
            let text = '';
            if(col != null) {
                const parts = col.split('.');
                //Call the propercase vue filter on the last element of the array
                text = this.propercase(parts[parts.length - 1]);
            }
            return {
                id: -1 * Math.random(),
                client_id: this.client.id,
                census_connection_id: this.source.id,
                source_column: (col == null) ? this.getBlankSourceColumn() : this.getGeneratedSourceColumn(col),
                destination_column: text,
                is_primary_identifier: is_primary,
            }
        },
        getBlankSourceColumn() {
            return {
                main_category: 'Columns',
                category: null,
                type: 'string',
                value: null,
                text: ""
            };
        },
        getGeneratedSourceColumn(col) {
            //Split the col by . and then call the filter to transform it
            const parts = col.split('.');
            //Call the propercase vue filter on the last element of the array
            const text = this.propercase(parts[parts.length - 1]);

            //TODO: Fill this out so it popuplates based upon the column
            return {
                main_category: 'Columns',
                category: (parts.length == 1 ? null : parts[0]),
                type: 'string',
                value: col,
                text: text
            };
        },
        updateConstant(column) {
            column.source_column.main_category = 'Static';
            column.destination_column = column.source_column.value;
        },
        toggleConstant(column) {
            //If it is a constant, switch back to the column
            if(this.isConstant(column))
                column.source_column.main_category = 'Columns';
            else
                column.source_column.main_category = 'Static';

            column.source_column.value = "";
        },
        isConstant(column) {
            if(Array.isArray(column.source_column)) return false;
            return column.source_column != null && column.source_column.main_category == 'Static';
        },
        isValid() {
            //Loop through the mapping and make sure that each column has a source and destination
            let valid = true;

            for(let i = 1; i < this.mapping.length; i++) {
                //There isn't a column selected
                if((this.mapping[i].source_column.value == null || this.mapping[i].source_column.value == "" ) && this.mapping[i].source_column.main_category == 'Columns') {
                    this.errors[i].source = "Please select a source column";
                    valid = false;
                }
                //There is a blank value
                else if(!Array.isArray(this.mapping[i].source_column) && (this.mapping[i].source_column.value == null || this.mapping[i].source_column.value == "")) {
                    this.errors[i].source = "Please enter a static value above";
                    valid = false;
                }
                else
                    this.errors[i].source = "";

                if(this.mapping[i].destination_column == null || this.mapping[i].destination_column == "") {
                    this.errors[i].destination = "Please enter the column name for your export";
                    valid = false;
                }
                else
                    this.errors[i].destination = "";
            }

            return valid;
        },
        removeColumn(i) {
            const col = this.mapping[i];

            //Remove the column
            this.mapping.splice(i, 1);
            this.errors.splice(i, 1);

            this.removeQuestions(col);
            this.$forceUpdate();
        },
        toggleExpand() {
            this.is_expanded = !this.is_expanded;
        }
    }
});
</script>